import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Paper,
  Alert,
} from '@mui/material';
import { createWorkspace } from '../app/api';
import { useWorkspace } from '../app/WorkspaceContext';
import { useTranslation } from '../app/LanguageContext';
import { SavingOverlay } from '../components/SavingOverlay';

const CreateWorkspacePage = () => {
  const { translate } = useTranslation();
  const { setCurrentWorkspace, refreshWorkspaces } = useWorkspace();
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!name || !name.trim()) {
      setError(translate('workspace.name_required'));
      setLoading(false);
      return;
    }

    try {
      const res = await createWorkspace({ name: name.trim() });
      const ws = res.data;
      if (ws) {
        await refreshWorkspaces();
        setCurrentWorkspace({ id: ws.id, name: ws.name });
        navigate('/');
        window.location.reload();
      } else {
        throw new Error('Invalid response');
      }
    } catch (err) {
      setError(err.message || translate('common.error'));
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2, textAlign: 'center' }}>
            {translate('workspace.create_first')}
          </Typography>
          <Box sx={{ mb: 3, p: 2, bgcolor: 'action.hover', borderRadius: 1 }}>
            <Typography variant="subtitle2" gutterBottom>
              {translate('workspace.explanation_title')}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {translate('workspace.explanation')}
            </Typography>
          </Box>
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }} noValidate>
            <TextField
              margin="normal"
              required
              fullWidth
              label={translate('workspace.name')}
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
            >
              {loading ? translate('common.saving') : translate('workspace.create_workspace')}
            </Button>
          </Box>
        </Paper>
      </Box>
      <SavingOverlay open={loading} />
    </Container>
  );
};

export default CreateWorkspacePage;
